"use client";

import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import FullPageLoader from "@/components/FullPageLoader";
import { ROUTES } from "@/config/routes";

export default function RedirectIfAuthed({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();

  if (loading) return <FullPageLoader message="Loading..." />;
  if (user) return <Navigate to={ROUTES.DASHBOARD} replace />;

  return <>{children}</>;
}
